import { GHOST_GREY, ATHENS_GREY, WHITE } from "../../../constants/colors";

const backgroundColor = WHITE;
const boxShadow = `0px 2px 14px 0px ${ATHENS_GREY}, 0px 3px 8px 0px ${GHOST_GREY}`;

export const fallbackValues = {
  backgroundColor,
  boxShadow
};
